// AlertLogoutPopup.jsx
import { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import useAuth from 'hooks/useAuth';
import { useQuery } from '@tanstack/react-query';
import { getUserByID } from 'services/users/getUserByID';

function AlertLogoutPopup() {
  const { logout } = useAuth();
  const [open, setOpen] = useState(false);

  const userid = JSON.parse(localStorage.getItem('userid'));
  const roleid = JSON.parse(localStorage.getItem('roleid'));

  const { data, isSuccess } = useQuery({
    queryFn: () => getUserByID({ userid, roleid }),
    queryKey: ['student-user-info', userid],
    enabled: !!userid && !!roleid
  });

  const studentData = data?.response || {};

  useEffect(() => {
    if (isSuccess && studentData?.status === 2) {
      setOpen(true);
    }
  }, [isSuccess, studentData]);

  const handleOk = () => {
    setOpen(false);
    logout();
  };

  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 600, color: 'error.main' }}>Account Deactivated</DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 1 }}>
          Hi <b>{studentData?.username || 'User'}</b>,
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Your account has been <b>deactivated by your coach</b>. This means you will no longer be able to access classes, materials, or
          other features until it is reactivated.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          👉 Please contact your coach directly for more details.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOk} variant="contained" color="primary">
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AlertLogoutPopup;
